"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Terminal = void 0;
const address_1 = __importDefault(require("../../../../address"));
class Terminal {
    constructor(data) {
        this.terminalNumber = data.terminalNumber;
        this.address = address_1.default.fromObj(data.address);
        this.limit = data.limit;
        this.constructionType = data.constructionType;
        this.protectiveMeasuresAndProtocols = data.protectiveMeasuresAndProtocols;
    }
    static empty() {
        const data = {
            terminalNumber: 0,
            address: address_1.default.empty(),
            limit: {
                currency: "USD",
                value: null
            },
            constructionType: "",
            protectiveMeasuresAndProtocols: []
        };
        return new Terminal(data);
    }
    static fromObj(data) {
        if (!data)
            return Terminal.empty();
        return new Terminal({
            terminalNumber: data.terminalNumber,
            address: data.address,
            limit: data.limit,
            constructionType: data.constructionType,
            protectiveMeasuresAndProtocols: data.protectiveMeasuresAndProtocols
        });
    }
}
exports.Terminal = Terminal;
//# sourceMappingURL=terminal.class.js.map